export default "__VITE_ASSET__OTPofWRb__"